


  $(".regions li" ).each(function() {
    var country =  $(this).find("a").text().trim();
    var flagImageName = country.split(' ').join('_').toLowerCase()
     $(this).find("a").prepend('<div class="flag uk"><img src="https://cdn.shopify.com/s/files/1/0832/0352/2906/files/'+flagImageName+'.webp" alt="'+country+' Flag"></div>')
    if( country == "United Kingdom"){
      $(this).find("a").addClass("active")
     
    }
  })
              
  $(".regions").on("click", "a", function(e){
    e.preventDefault()
    var flagAnchor = $(this)  
    changeWebsite(flagAnchor)
  })


  function changeWebsite(flagAnchor) {
    if (!flagAnchor) {return false};

    let flagURL = flagAnchor.attr("href");
    let siteLabel = flagAnchor.text().trim();
    //let flagImage = flagAnchor.querySelector('.flag img').src;
    let flagImageName = siteLabel.split(' ').join('_').toLowerCase();
    let flagImage = "https://cdn.shopify.com/s/files/1/0832/0352/2906/files/"+flagImageName+".webp";
    //https://cdn.shopify.com/s/files/1/0832/0352/2906/files/united_states.webp?v=1715696698
    let flagImageAlt = siteLabel;
    //let flagImageAlt = flagAnchor.querySelector('.flag img').alt;

    
    let regionModal = document.querySelector('.region-modal');
    let regionModalClose = document.querySelector('.modal-close');
    let regionModalCancel = document.querySelector('.modal-footer .cancel');

    document.body.addEventListener('click', (event) => {
      if (event.target == regionModal) {
        regionModal.style.display = "none";
      }
    });

    regionModalClose.addEventListener('click', () => {
      let regionModal = document.querySelector('.region-modal');
      regionModal.style.display = "none";
    });

    regionModalCancel.addEventListener('click', () => {                
      let regionModal = document.querySelector('.region-modal');
      regionModal.style.display = "none";            
    });

    if (typeof siteLabel !== 'string'
            && typeof flagURL !== 'string'
            && typeof flagImage !== 'string'
            && typeof flagImageAlt !== 'string'
       ) {return false};

    if (!regionModal) {return false};

    let newRegionInHeader = document.querySelector('.modal-header .new-region');
    newRegionInHeader.innerHTML = siteLabel;

    let newRegionInInnerContainer = document.querySelector('.inner-container .new-region');
    newRegionInInnerContainer.innerHTML = siteLabel;

    let newRegionModalFlag = document.querySelector('.modal-flag img');
    newRegionModalFlag.src = flagImage;
    newRegionModalFlag.alt = flagImageAlt;

    
    let newRegionContinueButton = document.querySelector('.region-modal .continue');
    newRegionContinueButton.href = flagURL;

    regionModal.style.display = "block";
    
  }
